import type { InspectionStatsCriteria } from '@hetivo/hetivo-lib-types';

import type { SearchInspectionsParams } from './inspection.api';

/**
 * Query-key factory for the Inspections feature (SWOOP-400). `stats` is keyed on the criteria object, so the
 * sidebar badge and the page's tab counts (both built from the master selector alone) hash to the same key and
 * share one fetch. That is what keeps the badge equal to the Due tab count (research R8, SC-003), as
 * `issue.keys.ts` does for the Issues badge.
 */
export const inspectionKeys = {
  all: ['inspections'] as const,
  search: (params: SearchInspectionsParams): readonly unknown[] => [...inspectionKeys.all, 'search', params] as const,
  stats: (criteria: InspectionStatsCriteria): readonly unknown[] => [...inspectionKeys.all, 'stats', criteria] as const,
};
